exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.home[data-v-49fce975] {\n  min-height: 600px;\n}\n.home > .title[data-v-49fce975] {\n  text-align: center !important;\n}\n", ""]);

// exports
